import { IconCheck } from '@tabler/icons-react';
import './Checkbox.scss';

export default function Checkbox({
    id,
    checked = false,
    onChange,
    disabled = false,
    label,
    hint,
    className = '',
}) {
    const rootClass = [
        'ui-checkbox',
        checked && 'ui-checkbox--checked',
        disabled && 'ui-checkbox--disabled',
        className,
    ].filter(Boolean).join(' ');

    return (
        <label className={rootClass} htmlFor={id}>
            <input
                id={id}
                type="checkbox"
                className="ui-checkbox__input"
                checked={checked}
                onChange={onChange}
                disabled={disabled}
            />
            <span className="ui-checkbox__box" aria-hidden="true">
                {checked && <IconCheck size={14} stroke={2} />}
            </span>
            <span className="ui-checkbox__content">
                {label && <span className="ui-checkbox__label">{label}</span>}
                {hint && <span className="ui-checkbox__hint">{hint}</span>}
            </span>
        </label>
    );
}
